<template>
  <div class="s-treeitem" :aria-expanded="isOpen() && item.children.length > 0 ? 'true' : 'false'">
    <div class="s-treeitem-container">
      <div class="s-treeitem-toggle" :class="{'is-open': isOpen()}" @click="onToggle()">
        <span class="s-treeitem-spacer" v-for="i in level - 1" :key="i"></span>
        <button type="button" class="s-treeitem-arrow" :class="{'is-open': isOpen()}" :aria-labelledby="'tree-label-' + item.id" v-if="item.hasChildren">
          <i class="ico ico-chevron-right-medium"></i>
        </button>
        <span class="s-treeitem-spacer" v-else></span>
        <input ref="checkbox" type="checkbox" :value="item" @change="onChangeItem($event)" :checked="isSelected()" v-if="level > 1">
        <p class="s-treeitem-content" :id="'tree-label-' + item.id">
          {{ item.content }}
        </p>
        <p v-if="isOpen() && item.children.length == 0 && (!item.search || item.search === '')" class="s-treeitem-loader"></p>
      </div>
      <template v-if="item.hasChildren && isOpen()">
        <NewTreeview
          :level="level"
          :item="item"
          :items="item.children"
          :opened="opened"
          :displayedMore="displayedMore"
          :selected="selected"
          v-on:open="onToggleOpen"
          v-on:select="onSelect" />
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Treeview-item',
  data: () => ({}),
  props: {
    item: {
      required: true
    },
    level: {
      default: 0
    },
    displayedMore: {
      required: true
    },
    opened: {
      required: true
    },
    selected: {
      required: true
    }
  },
  created() {},
  mounted() {},
  methods: {
    isOpen() {
      for(let i = 0; i < this.opened?.length; i++) {
        if(this.opened[i].id === this.item.id) return true;
      }
      return false;
    },

    isSelected() {
      for(let i = 0; i < this.selected?.length; i++) {
        if(this.selected[i].id === this.item.id) return true;
      }
      return false;
    },

    onToggle() {
      if(!this.item.hasChildren) return;
      this._timeoutToggle = setTimeout( () => {
        if(this.isOpen()) {
          let index = null;
          for( let i = 0; i < this.opened.length; i++) {
            if( this.opened[i].id === this.item.id) {
              index = i;
              break;
            }
          }
          this.opened.splice(index, 1);
        }
        else this.opened.push(this.item);
        this.$emit('open', {open: this.isOpen(), item: this.item});
      }, 50);
    },

    onChangeItem() {
      if(this._timeoutToggle) {
        clearTimeout(this._timeoutToggle);
        this._timeoutToggle = null;
      }
      const target = this.$refs.checkbox;
      this.selected = this.selected || [];
      if( target.checked ) this.selected.push( this.item );
      else {
        for( let i = 0; i < this.selected.length; i++ ) {
          if(this.selected[i].id === this.item.id) {
            this.selected.splice( i, 1 );
            break;
          }
        }
      }
      this.$emit('select', this.selected);
    },

    onToggleOpen(pEvt) {
      this.$emit('open', pEvt);
    },

    onSelect() {
      this.$emit('select', this.selected);
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    }
  }
}
</script>
<style scoped lang="scss">
  .viewer-element {
    .s-treeitem {
      input[type=checkbox] {
        flex-shrink: 0;
      }
      .s-treeitem-toggle {
        width: 100%;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        text-align: left;
        padding-top: rem(5);
        padding-bottom: rem(5);
        min-height: rem(35);
        padding-right: rem(10);
        &:hover {
          background-color: rgba($black, .05);
        }
        &.is-open {
          .s-treeview-arrow::before {
            transform: rotate(90deg);
          }
        }
      }
      .s-treeitem-spacer {
        display: block;
        flex-shrink: 0;
        width: rem(20);
      }
      .s-treeitem-loader {
        @include loader($black, .5);
        position: relative;
        display: inline-block;
        flex-shrink: 0;
        width: rem(20);
        height: rem(20);
        vertical-align: middle;
        margin-left: rem(5);
      }
      .s-treeitem-content {
        width: 100%;
        display: inline-block;
        line-height: 1;
        text-align: left;
        padding-left: rem(4);
      }
      .s-treeitem-arrow {
        @include resetBtn;
        position: relative;
        display: inline-flex;
        flex-shrink: 0;
        top: 0;
        width: rem(20);
        height: rem(20);
        border-radius: 100%;
        align-items: center;
        justify-content: center;
        outline: none;
        .ico {
          transition: transform .2s;
          opacity: .4;
        }
        &.is-open {
          .ico {
            transform: rotate(90deg);
          }
        }
        &:focus-visible {
          background-color: rgba($black, .1);
        }
      }
    }
  }
</style>